"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoriteButton = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var heartFilled = "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADqElEQVRoge2Yy2sUQRDGf5mNayQxgcSIoghG8KToSchN9KKI4MlLTuai4EnxL9CLN8lFwZsEJCJoDhpRjBJE0JiIj4Moie9HfG3czea9syO1U2OaQXdmJ7PxMh80O+z01FdfdXd1dZMgQYIECRIkSBAdNRG+lG8s/U3ps6XvHKAIFIxnjP61xrOgqH1so79TrfH0HF8G1N+E9ixcsOG9AwUHnCJ8yMLFe7ALaABWaGuQ/+Sd9JG+8o18KzbElthU21bEwAY6L9Gua4TmMehywFZH/tp+Qs9u2CRNnsv1FVtiU2wLh3LFKiKlkVz1BboDnPnTMvBYWtj+Yls4lCsVl/MSiTTQchuOhHUmahMO4VLOWEZBItEIbJyAl9UWIBzCpZyBo2AFvPcyR91R2NIAm+OISDkIh3DpWqgNGoUgAaiR+u2wtdrOe1CueuUui9AjUAerl8R7N/Sr4xoBL32mP8B0vG7+G8qVDpNOw0yh0k57pWR3aaBcVhj/wggobfdDMD4CH6utQDiEi4UyoyyCBDhap8wBM2fhXrUFKMeMctpBtVEYAfNqcOIMDD+Hz/G6vACxLRzCpZzzcQiQynIS+AV8PwTXZ1zDsUJsdsJ14VCuSaOq/SfC1huW9l3+BawcLNsLbXEKOA53e+Eh8BZ3lLPAbFwCMMrp9CDMNkFjO6xdvOvQBU9OQj/wGngH/DBGoCwqEeBForQ33ITcJmjd5hZekdENrw5DHzAKvAHGgJwu4sAsVKkA88SUugqZNmiJKuISvO6Aaxp5aZKmM7qA7TA2Kq25HeMIKLB6YbwNmisV0QOjHdDnuJGX9h74CUyFWbxRBDg+AbY3xL2QWQUrd0BrGEPn4EUn3PI5L/M+r84HTp0oAkwRtuZoTwg33NSX3hmwsE/B0xNwx910S86/09SZN2yGRtRjW9EQUfB2zAHIZaBmD6yr8RVhclg5Bo9OuzvtiBH5b7pxhVq0fizm3GmK8IQ4g5AfBXs/rE/pRlmAYifcPw8P1PkRt+gsOZ83nK/4SmWxB2dPREGdKM3fZzA5DFMHYMM82Aeh/zIM+SLvzfnIzhPmxFMGZqE3YThRGpU+mNoHX+XzgYUUKXn+k7FRVTzn/Yjr7uXPhZfeKKzR1qTvs7pBjWmq9JyveM77sZgRMFFUhyaN55wKQv/PapE2HZfzVOEKz9KgLNczbVr/n9PddbbSPB+E2O8gfRe/XpKwfRe4saEaAjz4bVft1jlBggQJ/hOA39UB6ufSxdB6AAAAAElFTkSuQmCC')";
var heartEmpty = "url('data:image/png;base64,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')";
var useFavoriteButtonStyles = (0, react_jss_1.createUseStyles)({
    heart: {
        width: "24px",
        height: "24px",
        minWidth: "24px",
        marginTop: "0px",
        marginBottom: "0px",
        marginInlineStart: "-5px",
        marginInlineEnd: "-2px",
        backgroundRepeat: "no-repeat",
        backgroundSize: "24px 24px",
        backgroundPosition: "center",
        transformOrigin: "center",
        transform: "scale(1)",
        transitionDuration: "100ms",
        transitionProperty: "transform",
        "&:hover": {
            transform: "scale(1.125)",
        },
    },
    heartFilled: {
        backgroundImage: heartFilled,
    },
    heartEmpty: {
        backgroundImage: heartEmpty,
    },
});
var FavoriteButton = function (props) {
    var locator = props.isFavorite ? "search.favorite" : "search.not.favorite";
    var classes = useFavoriteButtonStyles();
    var backgroundImage = props.isFavorite ? classes.heartFilled : classes.heartEmpty;
    return (React.createElement("div", { className: "".concat(classes.heart, " ").concat(backgroundImage), "data-ta-locator": locator, onClick: props.onClick ? props.onClick : undefined }));
};
exports.FavoriteButton = FavoriteButton;
exports.FavoriteButton.displayName = "FavoriteButton";
//# sourceMappingURL=FavoriteButton.js.map